// extracted by mini-css-extract-plugin
module.exports = {"gridRow":"basic-data-config_gridRow__2ouP0","buttonConfig":"basic-data-config_buttonConfig__2eMXA"};